import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "mobile-user-profile container"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "avatar"
};
const _hoisted_4 = {
  key: 1,
  class: "opt"
};
const _hoisted_5 = {
  class: "product-list"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = {
  class: "pay-btn"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "price"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  class: "setting-content"
};
import { onMounted, ref } from "vue";
import { showFailToast, showLoadingToast, showNotify, showSuccessToast } from "vant";
import { httpGet, httpPost } from "@/utils/http";
import { dateFormat, showLoginDialog } from "@/utils/libs";
import { ElMessage } from "element-plus";
import { checkSession, getSystemInfo } from "@/store/cache";
import { useRouter } from "vue-router";
import { removeUserToken } from "@/store/session";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'Profile',
  setup(__props) {
    const form = ref({
      username: "ZHIPAIMaster",
      nickname: "游客@001",
      mobile: "1300000000",
      avatar: "",
      power: 0
    });
    const fileList = ref([{
      url: "/images/user-info.png",
      message: "上传中..."
    }]);
    const products = ref([]);
    const vipMonthPower = ref(0);
    const payWays = ref({});
    const router = useRouter();
    const userId = ref(0);
    const isLogin = ref(false);
    const showSettings = ref(false);
    const store = useSharedStore();
    const stream = ref(store.chatStream);
    const dark = ref(store.theme === "dark");
    onMounted(() => {
      checkSession().then(user => {
        userId.value = user.id;
        isLogin.value = true;
        httpGet("/user/profile").then(res => {
          form.value = res.data;
          fileList.value[0].url = form.value.avatar;
        }).catch(e => {
          console.log(e.message);
          showFailToast("获取用户信息失败");
        });
      }).catch(() => {});

      // 获取产品列表
      httpGet("/product/list").then(res => {
        products.value = res.data;
      }).catch(e => {
        showFailToast("获取产品套餐失败：" + e.message);
      });
      getSystemInfo().then(res => {
        vipMonthPower.value = res.data["vip_month_power"];
      }).catch(e => {
        showFailToast("获取系统配置失败：" + e.message);
      });
      httpGet("/payment/payWays").then(res => {
        payWays.value = res.data;
      }).catch(e => {
        ElMessage.error("获取支付方式失败：" + e.message);
      });
    });

    // const afterRead = (file) => {
    //   file.status = 'uploading';
    //   file.message = '上传中...';
    //   // 压缩图片并上传
    //   new Compressor(file.file, {
    //     quality: 0.6,
    //     success(result) {
    //       const formData = new FormData();
    //       formData.append('file', result, result.name);
    //       // 执行上传操作
    //       httpPost('/api/upload', formData).then((res) => {
    //         form.value.avatar = res.data.url
    //         file.status = 'success'
    //         httpPost('/api/user/profile/update', form.value).then(() => {
    //           showSuccessToast('上传成功')
    //         }).catch(() => {
    //           showFailToast('上传失败')
    //         })
    //       }).catch((e) => {
    //         showNotify({type: 'danger', message: '上传失败：' + e.message})
    //       })
    //     },
    //     error(err) {
    //       console.log(err.message);
    //     },
    //   });
    // }

    const showPasswordDialog = ref(false);
    const pass = ref({
      old: "",
      new: "",
      renew: ""
    });
    const beforeClose = action => {
      new Promise(resolve => {
        resolve(action === "confirm");
      });
    };

    // 提交修改密码
    const updatePass = () => {
      if (pass.value.old === "") {
        return showNotify({
          type: "danger",
          message: "请输入旧密码"
        });
      }
      if (!pass.value.new || pass.value.new.length < 8) {
        return showNotify({
          type: "danger",
          message: "密码的长度为8-16个字符"
        });
      }
      if (pass.value.renew !== pass.value.new) {
        return showNotify({
          type: "danger",
          message: "两次输入密码不一致"
        });
      }
      httpPost("/user/password", {
        old_pass: pass.value.old,
        password: pass.value.new,
        repass: pass.value.renew
      }).then(() => {
        showSuccessToast("更新成功！");
        showPasswordDialog.value = false;
      }).catch(e => {
        showFailToast("更新失败，" + e.message);
        showPasswordDialog.value = false;
      });
    };
    const pay = (product, payWay) => {
      if (!isLogin.value) {
        return showLoginDialog(router);
      }
      showLoadingToast({
        message: "正在创建订单",
        forbidClick: true
      });
      let host = process.env.VUE_APP_API_HOST;
      if (host === "") {
        host = `${location.protocol}//${location.host}`;
      }
      httpPost(`${process.env.VUE_APP_API_HOST}/api/payment/doPay`, {
        product_id: product.id,
        pay_way: payWay.pay_way,
        pay_type: payWay.pay_type,
        user_id: userId.value,
        host: host,
        device: "wechat"
      }).then(res => {
        location.href = res.data;
      }).catch(e => {
        showFailToast("生成支付订单失败：" + e.message);
      });
    };
    const logout = function () {
      httpGet("/user/logout").then(() => {
        removeUserToken();
        store.setIsLogin(false);
        router.push("/");
      }).catch(() => {
        showFailToast("注销失败！");
      });
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_tag = _resolveComponent("van-tag");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_col = _resolveComponent("van-col");
      const _component_van_row = _resolveComponent("van-row");
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_dialog = _resolveComponent("van-dialog");
      const _component_van_switch = _resolveComponent("van-switch");
      const _component_van_action_sheet = _resolveComponent("van-action-sheet");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [isLogin.value ? (_openBlock(), _createBlock(_component_van_form, {
        key: 0
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_image, {
          src: fileList.value[0].url,
          size: "80",
          width: "80",
          fit: "cover",
          round: ""
        }, null, 8, ["src"])]), _createVNode(_component_van_cell_group, {
          inset: "",
          modelValue: form.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_van_field, {
            modelValue: form.value.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.username = $event),
            label: "账号",
            readonly: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: form.value.nickname,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.nickname = $event),
            label: "昵称",
            readonly: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            label: "算力"
          }, {
            input: _withCtx(() => [_createVNode(_component_van_tag, {
              type: "primary"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(form.value.power), 1)]),
              _: 1
            })]),
            _: 1
          }), form.value.expired_time > 0 ? (_openBlock(), _createBlock(_component_van_field, {
            key: 0,
            label: "有效期"
          }, {
            input: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(dateFormat)(form.value.expired_time)), 1)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })) : _createCommentVNode("", true), isLogin.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_van_row, {
        gutter: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_van_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_van_button, {
            round: "",
            block: "",
            onClick: _cache[3] || (_cache[3] = $event => showPasswordDialog.value = true),
            size: "small"
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("修改密码")])),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_van_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_van_button, {
            round: "",
            block: "",
            onClick: logout,
            size: "small"
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("退出登录")])),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_van_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_van_button, {
            round: "",
            block: "",
            onClick: _cache[4] || (_cache[4] = $event => showSettings.value = true),
            icon: "setting",
            size: "small"
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("设置")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_cache[23] || (_cache[23] = _createElementVNode("h3", null, "充值套餐", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.id
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payWays.value, payWay => {
          return _openBlock(), _createElementBlock("div", {
            onClick: $event => pay(item, payWay),
            key: payWay
          }, [_createElementVNode("span", null, [payWay.pay_type === 'alipay' ? (_openBlock(), _createBlock(_component_van_button, {
            key: 0,
            type: "primary",
            size: "small"
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [_createElementVNode("i", {
              class: "iconfont icon-alipay"
            }, null, -1), _createTextVNode(" 支付宝 ")])),
            _: 1
          })) : _createCommentVNode("", true), payWay.pay_type === 'wxpay' ? (_openBlock(), _createBlock(_component_van_button, {
            key: 1,
            type: "success",
            size: "small"
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [_createElementVNode("i", {
              class: "iconfont icon-wechat-pay"
            }, null, -1), _createTextVNode(" 微信支付 ")])),
            _: 1
          })) : _createCommentVNode("", true)])], 8, _hoisted_9);
        }), 128))])]), _createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [_createVNode(_component_van_cell, {
            title: "商品价格"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_10, " ￥" + _toDisplayString(item.discount), 1), _cache[20] || (_cache[20] = _createTextVNode(" （ ")), _createElementVNode("del", null, "￥" + _toDisplayString(item.price), 1), _cache[21] || (_cache[21] = _createTextVNode(" ） "))]),
            _: 2
          }, 1024), _createVNode(_component_van_cell, {
            title: "有效期"
          }, {
            default: _withCtx(() => [item.days > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.days) + "天", 1)) : (_openBlock(), _createBlock(_component_van_tag, {
              key: 1,
              type: "primary"
            }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("长期有效")])),
              _: 1
            }))]),
            _: 2
          }, 1024), _createVNode(_component_van_cell, {
            title: "算力值"
          }, {
            default: _withCtx(() => [item.power > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.power), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(vipMonthPower.value), 1))]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)]);
      }), 128))])]), _createVNode(_component_van_dialog, {
        show: showPasswordDialog.value,
        "onUpdate:show": _cache[8] || (_cache[8] = $event => showPasswordDialog.value = $event),
        title: "修改密码",
        "show-cancel-button": "",
        onConfirm: updatePass,
        onCancel: _cache[9] || (_cache[9] = $event => showPasswordDialog.value = false),
        "before-close": beforeClose
      }, {
        default: _withCtx(() => [_createVNode(_component_van_form, null, {
          default: _withCtx(() => [_createVNode(_component_van_cell_group, {
            inset: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_van_field, {
              modelValue: pass.value.old,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => pass.value.old = $event),
              placeholder: "旧密码"
            }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
              modelValue: pass.value.new,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => pass.value.new = $event),
              type: "password",
              placeholder: "新密码"
            }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
              modelValue: pass.value.renew,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => pass.value.renew = $event),
              type: "password",
              placeholder: "确认密码"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_action_sheet, {
        show: showSettings.value,
        "onUpdate:show": _cache[14] || (_cache[14] = $event => showSettings.value = $event),
        title: "用户设置"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_component_van_form, null, {
          default: _withCtx(() => [_createVNode(_component_van_cell_group, {
            inset: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_van_field, {
              name: "switch",
              label: "暗黑主题"
            }, {
              input: _withCtx(() => [_createVNode(_component_van_switch, {
                modelValue: dark.value,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => dark.value = $event),
                onChange: _cache[11] || (_cache[11] = val => _unref(store).setTheme(val ? 'dark' : 'light'))
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_van_field, {
              name: "switch",
              label: "流式输出"
            }, {
              input: _withCtx(() => [_createVNode(_component_van_switch, {
                modelValue: stream.value,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => stream.value = $event),
                onChange: _cache[13] || (_cache[13] = val => _unref(store).setChatStream(val))
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }, 8, ["show"])]);
    };
  }
};